/* eslint-disable no-nested-ternary */
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AddPersonInGroup } from 'Types/RequestBodies';
import { actions } from 'Slice/GroupsSlice';
import { actions as buyerGroupActions } from 'Slice/BuyerGroupsPageSlice';
import { Tooltip } from 'antd';
import {
  maxWidth,
  primaryColor, primaryFont, primaryHeadingColor, retina,
  SecondaryColor, secondaryFont, smMobile, wMBold, wMedium,
} from 'Utils/utilsStyle';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { selectData } from 'Selector/CertificationSelector';
import GlobalButton from 'Components/common/components/GlobalButton';
import { getCurrentTime, valueToObject } from 'Utils/UtilityFunctions';
import SmartInputAddIcon from 'Components/common/assets/svgIcons/SmartInputAddIcon';
import SmartInputRemoveIcon from 'Components/common/assets/svgIcons/SmartInputRemoveIcon';
import {
  selectAccountSelectedPeople, selectLiveExecIds, selectLoadingLiveIds, selectShowSelectedPeople,
} from 'Selector/CompaniesSelector';
import { selectAddingPersonIds } from 'Selector/GroupsSelector';

type Props = {
  title?: string,
  personId?: number,
  profilePic?: string,
  persona?: string,
  designation?: string,
  company?: string,
  isPersonAdded?: boolean,
  isFollowed?: boolean,
  personType?: string
  isRecommended?: boolean
  isNetwork?: boolean
  clicked?: boolean
  showAddIcon?: boolean
  companyId?: number,
  location?: string,
  onClickAdd?: () => void
  onClickRemove?: () => void
} & typeof defaultProps;

const defaultProps = {
  title: 'Harsha Buksh',
  profilePic: 'https://picsum.photos/200',
  persona: '#E79540 0%,#37CC10 31%,#E3433F 69%,#306FE8 100%',
  designation: 'President/ Co-founder',
  company: 'Walsh - Brekke',
  personId: 0,
  isPersonAdded: false,
  isFollowed: false,
  personType: 'EXECUTIVE',
  isRecommended: false,
  isNetwork: false,
  clicked: false,
  showAddIcon: false,
  companyId: 0,
  location: '',
  onClickAdd: () => { },
  onClickRemove: () => { },
};

const Wrapper = styled.div`
   box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
   border-radius: 10px;
   background-color: #fff;
   padding: 18px 14px;
   margin-bottom: 10px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 10px;
    }
    @media all and (max-width: ${smMobile}) {
      .left-side {
        width: 50px;
      }
      .right-side {
        width: calc(100% - 50px);
        button {
          min-width: 30%;
          justify-content: center;
        }
      }

    }
  .text-area {
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-left: 10px;
      }
    .heading {
      font-family: ${secondaryFont};
      font-size: 20px;
      line-height: 26px;
      font-weight: ${wMedium};
      color: #000;
      margin-bottom: 0px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 16px;
        margin-bottom: -5px;
      }
      @media all and (max-width: ${maxWidth}) {
        font-size: 16px;
        margin-bottom: -5px;
      }
    }
    .company {
      color: ${primaryHeadingColor};
      font-weight: ${wMedium};
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 0px;
      font-family: ${primaryFont};
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 12px;
      }
    }
    .person-tooltip{
      .ant-tooltip-content{
        width: fit-content;
        .ant-tooltip-inner{
          color: ${primaryHeadingColor};
          font-family: ${primaryFont};
          font-weight: ${wMBold};
          line-height: 16px;
          letter-spacing: -0.4px;
          padding: 7px 16px;
          border-radius: 5px;
          min-height: unset;
          margin-bottom: -11px;
          border-radius: 4px;
        }
      }
    }
    .designation {
      color: ${primaryColor};
      font-weight: ${wMedium};
      font-size: 14px;
      line-height: 14px;
      margin-bottom: 0px;
      font-family: ${primaryFont};
      @media all and (max-width: ${maxWidth}) , ${retina} {
       font-size: 12px;
      }
    }
  }
  .action-btn {
   background-color: ${SecondaryColor};
   border-radius: 13px;
   padding: 6px 12px;
   color: #fff;
   font-family: ${primaryFont};
   font-size: 10px;
   cursor: pointer;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 7px;
      padding: 3px 7px;
      white-space: pre;
    }
  }
  .disabled {
    pointer-events: none;
  }
  .right-side {
    width: calc(100% - 55px);
    .add-remove-div {
      cursor: pointer;
      height: 19px;
    }
  }
`;

const PersonDisplayWidget = function PersonDisplayWidget(props: Props) {
  const {
    title, profilePic, persona, company, designation, showAddIcon,
    personId, isPersonAdded, isFollowed, personType, isRecommended, clicked,
    onClickAdd, onClickRemove, isNetwork, companyId, location,
  } = props;
  const dispatch = useDispatch();
  const url = new URLSearchParams(window.location.search);
  const groupId: number = parseInt(url.get('groupId') || '0', 10);
  const data = useSelector(selectData);
  const startTime = getCurrentTime();
  const showSelectedPeople = useSelector(selectShowSelectedPeople);
  const selectedPeople = useSelector(selectAccountSelectedPeople);
  const liveExecIds = useSelector(selectLiveExecIds);
  const loadingLiveIds = useSelector(selectLoadingLiveIds);
  const addingPersonIds = useSelector(selectAddingPersonIds);
  const host = window.location.href;
  const [isClicked, setIsClicked] = useState(false);

  // Reset local clicked state when person is no longer being added
  useEffect(() => {
    let isMounted = true;

    if (isClicked && !addingPersonIds.includes(personId || 0)) {
      // Use setTimeout to defer state update to next tick
      setTimeout(() => {
        if (isMounted) {
          setIsClicked(false);
        }
      }, 0);
    }

    return () => {
      isMounted = false;
    };
  }, [addingPersonIds, isClicked]);

  const addToGroup = () => {
    if (!clicked && !isClicked) {
      setIsClicked(true);
      dispatch(certificationActions.certificationAction({
        type: 'add_person_browser',
        source: 'buyer',
        data,
      }));
      const object: AddPersonInGroup = {
        group_id: groupId,
        person_data: [{
          type: personType,
          query: title,
          entity_id: personId,
        }],
        isFollowed,
      };
      dispatch(buyerGroupActions.memberAddClicked({ personId, clicked: true, isRecommended }));
      dispatch(actions.addPersonInGroup(object));
      if (isRecommended) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('clicked_addtoGroup_recommended', startTime, {
            person_id: personId,
            group_id: groupId,
            host,
          }),
        ));
      } else if (isNetwork) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('clicked_addtoGroup_myNetwork', startTime, {
            person_id: personId,
            group_id: groupId,
            host,
          }),
        ));
      } else {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('clicked_addtoGroup_search', startTime, {
            person_id: personId,
            group_id: groupId,
            type: personType,
            host,
          }),
        ));
      }
    }
  };

  return (
    <Wrapper className="person-display-widget-wrapper d-flex align-items-center">
      <div className="left-side">
        <PeopleWidgetWithOutHolo
          logo={profilePic}
          wrapperColor={persona}
          persona={persona}
          diameter="55px"
          diameterSm="45px"
          diameterXsm="45px"
          margin="0px 15px 0px 0px"
          marginSm="0px 3px 0px 3px"
          ringPadding="2px"
          ringPaddingSm="2px"
        />
      </div>
      <div className="right-side d-flex align-items-center justify-content-between">
        <div className="text-area w-70">
          <h6 className="heading text-truncate-one-line">{title}</h6>
          <span className="company text-truncate-one-line">{companyId === 1880420 ? '' : company}</span>
          <div className="w-70">
            <Tooltip
              arrow={false}
              placement="topLeft"
              title={companyId === 1880420 ? (location?.length ? location : company) : designation}
              color="#fff"
              className="person-tooltip"
              getPopupContainer={
                (e: HTMLElement) => e
              }
            >
              <span className="designation text-truncate-one-line">{companyId === 1880420 ? (location?.length ? location : company) : designation}</span>
            </Tooltip>
          </div>
        </div>
        {showAddIcon ? (
          <div className="add-remove-div">
            {!showSelectedPeople && !selectedPeople.some((person) => person.personId === personId)
              && !liveExecIds.some((id) => id.liveId === personId)
              ? <SmartInputAddIcon className="" onClick={onClickAdd} />
              : (
                <SmartInputRemoveIcon
                  className={loadingLiveIds?.includes(personId) ? 'disabled' : ''}
                  onClick={onClickRemove}
                />
              )}
          </div>
        ) : (
          <GlobalButton
            title={`${isPersonAdded ? 'Add to Group' : 'Added'}`}
            textColor={`${isPersonAdded ? '#ffffff' : '#001760'}`}
            bgColor={`${isPersonAdded ? '#001760' : '#fff'}`}
            PaddingSm={`${isPersonAdded ? '4px 10px 4px 10px' : '4px 20px 4px 20px'}`}
            PaddingXxsm="4px 3px 4px 3px"
            innerSpace={`${isPersonAdded ? '4px 10px 4px 10px' : '4px 20px 4px 20px'}`}
            fontSize="10px !important"
            borderRadius="13px"
            outlineColor="#001760"
            onButtonClick={addToGroup}
            disabled={
              !!clicked || !isPersonAdded || isClicked || addingPersonIds.includes(personId || 0)
            }
          />
        )}
      </div>
    </Wrapper>
  );
};

PersonDisplayWidget.defaultProps = defaultProps;
export default PersonDisplayWidget;